const QUOTES = [
  {
    text: "The institute demonstrated how to decouple our small business operations from restrictive systems and operate on direct trade. The education is thorough, uncompromised, and provided without tuition.",
    attribution: "Nevada Trade Member · Verified Business League Participant",
    testid: "member-quote-1",
  },
  {
    text: "Having direct access to mentors six hours a day across health, financial structuring, and psychology gave our family and enterprise total clarity on true self-sufficiency.",
    attribution: "Henderson Resident · League Edification Graduate",
    testid: "member-quote-2",
  },
];

// NOTE: These quotes are illustrative placeholders until real member
// testimonials are supplied by the Institute.
const Proof = () => {
  return (
    <section
      id="proof"
      data-testid="proof-section"
      className="py-24 px-6 border-b border-stone-800 max-w-7xl mx-auto"
    >
      <div className="space-y-8">
        <div className="text-center max-w-xl mx-auto space-y-2">
          <span className="mono-tag text-xs uppercase tracking-widest text-amber-500">
            Member Verification
          </span>
          <h2 className="text-3xl font-bold tracking-tight text-stone-100 display-serif">
            Authentic Autonomy
          </h2>
        </div>
        <div className="grid md:grid-cols-2 gap-6">
          {QUOTES.map((quote) => (
            <figure
              key={quote.testid}
              data-testid={quote.testid}
              className="p-8 rounded-2xl bg-stone-900/60 border border-stone-800 space-y-4"
            >
              <blockquote className="text-sm text-stone-300 italic leading-relaxed">
                "{quote.text}"
              </blockquote>
              <figcaption className="text-xs font-semibold text-amber-400">
                {quote.attribution}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Proof;
